import { render, staticRenderFns } from "./TeamMemberCustomFieldsList.vue?vue&type=template&id=39151d30&"
import script from "./TeamMemberCustomFieldsList.vue?vue&type=script&lang=js&"
export * from "./TeamMemberCustomFieldsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39151d30')) {
      api.createRecord('39151d30', component.options)
    } else {
      api.reload('39151d30', component.options)
    }
    module.hot.accept("./TeamMemberCustomFieldsList.vue?vue&type=template&id=39151d30&", function () {
      api.rerender('39151d30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/BookingFields/components/TeamMemberCustomFieldsList.vue"
export default component.exports